<template>
  <Event ref="eventRef" :event="mappedEvent" v-bind="$attrs">
    <!-- Prettier should not make a break in the following div -->
    <div class="white-space-pre font-bold">{{ event.description }}</div>
    <template v-if="event.customAttributes && event.customAttributes.length > 0">
      <div
        v-for="field in event.customAttributes"
        :key="`event-${event.id}-attribute-${field.name}`"
        style="
          display: flex;
          flex-direction: row;
          width: 100%;
          align-items: flex-start;
          gap: 0.5rem;
        "
        class="mt-1"
      >
        <div class="text-nowrap" style="display: flex; flex: 1; font-weight: bold">
          <b>{{ te(`module.sbb.${field.name}`) ? t(`module.sbb.${field.name}`) : field.name }}</b>
        </div>
        <div style="display: flex; flex: 5; align-items: flex-start">
          <span v-if="field.type === IssueCustomAttributesType.NUMBER">
            {{ field.value == null ? "" : n(field.value) }}
          </span>
          <div v-if="field.type === IssueCustomAttributesType.TEXT" class="white-space-pre">
            {{ field.value }}
          </div>
          <div v-if="field.type === IssueCustomAttributesType.TEXTAREA" class="white-space-pre">
            {{ field.value }}
          </div>
          <i
            v-if="field.type === IssueCustomAttributesType.BOOLEAN"
            :class="field.value === true ? 'fas fa-check' : 'fas fa-times'"
            :color="field.value === true ? 'success' : undefined"
          ></i>
        </div>
      </div>
    </template>
    <template #trailingHeaderAdditionsFront>
      <AttachmentBadge :files="mappedEvent.Folder?.files" />
    </template>
    <template v-for="(_, slot) of $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </Event>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import { computed, type PropType, provide, ref } from "vue";
import { IssueCustomAttributesType, type EventListEventFields_Issue_Fragment } from "@/graphql";
import AttachmentBadge from "@/components/badges/AttachmentBadge.vue";
import Event from "../event/EventComponent.vue";
import { CreateInjectionKey } from "./IssueTypes";

const props = defineProps({
  event: {
    type: Object as PropType<EventListEventFields_Issue_Fragment>,
    required: true,
  },
});

defineSlots();

provide(
  CreateInjectionKey,
  computed(() => false),
);
const eventRef = ref<InstanceType<typeof Event>>();
const mappedEvent = computed(() => ({
  ...props.event,
}));

defineExpose({
  eventRef,
});

const { t, te, n } = useTranslation();
</script>

<style lang="scss" scoped></style>
